import LogRocket from 'logrocket';

// src/identify.ts
var identifyAnonymous = (uniqueId) => {
  LogRocket.identify(uniqueId);
};
var identify = (uniqueId, user) => {
  LogRocket.identify(uniqueId, buildUserTraits(user));
};
var buildUserTraits = (user) => {
  const { userId, organizationId, organizationName, isMigratedToWorkleap, isOrganizationCreator, isAdmin, isExecutive, isCollaborator, isReportingManager, isTeamManager, planCode } = user;
  const isExecutiveInAnyProduct = Boolean(isExecutive?.wov || isExecutive?.lms || isExecutive?.onb || isExecutive?.sks || isExecutive?.wpm || isExecutive?.pbd);
  const isCollaboratorInAnyProduct = Boolean(isCollaborator?.wov || isCollaborator?.lms || isCollaborator?.onb || isCollaborator?.sks || isCollaborator?.wpm || isCollaborator?.pbd);
  let additionalTraits = {};
  if (user.additionalTraits !== void 0) {
    const props = user.additionalTraits;
    additionalTraits = user.additionalTraits !== void 0 ? Object.keys(user.additionalTraits).reduce((acc, key) => props[key] === void 0 ? { ...acc } : { ...acc, [key]: props[key] }, {}) : {};
  }
  return {
    ...additionalTraits,
    "User Id": userId,
    "Organization Id": organizationId,
    "Organization Name": organizationName,
    "Is Migrated To Workleap": isMigratedToWorkleap,
    "Is Admin": isAdmin,
    ...isOrganizationCreator !== void 0 && { "Is Organization Creator": isOrganizationCreator },
    ...isExecutiveInAnyProduct && { "Is Executive": true },
    ...isExecutive?.wov !== void 0 && { "Is Executive - Officevibe": isExecutive.wov },
    ...isExecutive?.lms !== void 0 && { "Is Executive - LMS": isExecutive.lms },
    ...isExecutive?.onb !== void 0 && { "Is Executive - Onboarding": isExecutive.onb },
    ...isExecutive?.sks !== void 0 && { "Is Executive - Skills": isExecutive.sks },
    ...isExecutive?.wpm !== void 0 && { "Is Executive - Performance": isExecutive.wpm },
    ...isExecutive?.pbd !== void 0 && { "Is Executive - Pingboard": isExecutive.pbd },
    ...isCollaboratorInAnyProduct && { "Is Collaborator": isCollaboratorInAnyProduct },
    ...isCollaborator?.wov !== void 0 && { "Is Collaborator - Officevibe": isCollaborator.wov },
    ...isCollaborator?.lms !== void 0 && { "Is Collaborator - LMS": isCollaborator.lms },
    ...isCollaborator?.onb !== void 0 && { "Is Collaborator - Onboarding": isCollaborator.onb },
    ...isCollaborator?.sks !== void 0 && { "Is Collaborator - Skills": isCollaborator.sks },
    ...isCollaborator?.wpm !== void 0 && { "Is Collaborator - Performance": isCollaborator.wpm },
    ...isCollaborator?.pbd !== void 0 && { "Is Collaborator - Pingboard": isCollaborator.pbd },
    ...isReportingManager !== void 0 && { "Is Reporting Manager": isReportingManager },
    ...isTeamManager !== void 0 && { "Is Team Manager": isTeamManager },
    ...planCode?.wov !== void 0 && { "Plan Code - Officevibe": planCode.wov },
    ...planCode?.lms !== void 0 && { "Plan Code - LMS": planCode.lms },
    ...planCode?.onb !== void 0 && { "Plan Code - Onboarding": planCode.onb },
    ...planCode?.sks !== void 0 && { "Plan Code - Skills": planCode.sks },
    ...planCode?.wpm !== void 0 && { "Plan Code - Performance": planCode.wpm },
    ...planCode?.pbd !== void 0 && { "Plan Code - Pingboard": planCode.pbd }
  };
};

export { buildUserTraits, identify, identifyAnonymous };
